import { Button, Tooltip } from 'antd';
import React, { useState } from 'react';
import ReviewCopyDownloadModalAnchor from '../ReviewCopy/ReviewCopyDownloadModalAnchor';
import ReviewCopyRequestModalAnchor from '../ReviewCopy/ReviewCopyRequestModalAnchor';
import ArchiveRequest from '../UI/Actions/ArchiveRequest';
import CancelRequest from '../UI/Actions/CancelRequest';
import ReviewTitle from '../UI/Actions/ReviewTitle';
import RemoveTitleFromList from '../UI/Actions/Titles/RemoveTitleFromList';
import './titleActivityTile.css';
import TitleDataStore from './containers/TitleDataStore';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import PropTypes from 'prop-types';
import EdelweissReaderLink from '../ReviewCopy/EdelweissReaderLink';
import { useWebReaderGalleyAccess } from '../hooks/useWebReaderGalleyAccess';

export const TitleActions = ({
	request,
	download,
	review,
	title,
	doNotShowSelect,
	removeFromCollaborativeList,
	isMobile,
	isSelected,
	selectTitle,
	positionBottomRight = false,
}) => {
	const [valueChanged, setValueChanged] = useState(false);
	const [isChangedSelected, setIsChangeSelected] = useState(false);
	const isMobileSize = isMobile();
	const { sku } = title;
	const { hasWebReaderGalleyAccess } = useWebReaderGalleyAccess();

	const renderSelect = sku => {
		var displaySelected = valueChanged ? isChangedSelected : isSelected;
		displaySelected =
			displaySelected !== isSelected ? isSelected : displaySelected;
		const icon = !displaySelected ? 'icon-mark-icon' : 'icon-undo';
		const changeTo = displaySelected ? 1 : 0;
		return (
			<Tooltip
				title={`${!displaySelected ? 'Select' : 'Unselect'}`}
				placement="topRight">
				<div
					className="clickable"
					onClick={() => changeStatus(sku, changeTo)}>
					<Button
						shape="circle"
						size="small"
						style={{
							backgroundColor: `${
								!displaySelected
									? 'rgb(245, 245, 245)'
									: '#ffc321'
							}`,
						}}>
						<div
							className={icon}
							style={{
								fontSize: '15px',
								marginTop: '2px',
								color: `${
									!displaySelected ? '#545454' : '#ffffff'
								}`,
							}}
						/>
					</Button>
				</div>
			</Tooltip>
		);
	};

	const changeStatus = (sku, isSelected) => {
		const isChangedSelected = isSelected ? false : true;
		setValueChanged(true);
		setIsChangeSelected(isChangedSelected);
		selectTitle(sku, isChangedSelected);
	};

	return (
		<div
			className={
				isMobileSize && positionBottomRight
					? 'list-action-frame-mobile'
					: 'list-action-frame'
			}>
			{!doNotShowSelect && (
				<div
					className={`${
						isMobileSize ? 'margin-top-5 ' : ''
					}column-right pad-left-10`}>
					{renderSelect(title.sku)}
				</div>
			)}
			{removeFromCollaborativeList && (
				<div className="column-right pad-left-10">
					<RemoveTitleFromList sku={title.sku} />
				</div>
			)}
			{hasWebReaderGalleyAccess(sku) && (
				<div className="column-right pad-left-5">
					<EdelweissReaderLink title={title} buttonType="round" />
				</div>
			)}
			{request && !request.status && (
				<div className="column-right pad-left-10">
					<CancelRequest
						id={request.id}
						submittedDate={request.submittedDate}
						sku={title.sku}
					/>
				</div>
			)}
			{download ? (
				<div className="column-right">
					<ReviewCopyDownloadModalAnchor
						title={title}
						downloadDate={download.downloadDate}
						digitalCreatedDate={title.digitalCreatedDate}
						digitalUpdatedDate={title.digitalUpdatedDate}
					/>
				</div>
			) : (
				<React.Fragment>
					{title.isDownloadable ? (
						<div className="column-right">
							<ReviewCopyDownloadModalAnchor
								title={title}
								digitalCreatedDate={title.digitalCreatedDate}
								digitalUpdatedDate={title.digitalUpdatedDate}
							/>
						</div>
					) : (
						<React.Fragment>
							{title.isRequestable && !request && (
								<div className="column-right pad-left-10">
									<ReviewCopyRequestModalAnchor
										title={title}
										digitalCreatedDate={
											title.digitalCreatedDate
										}
										digitalUpdatedDate={
											title.digitalUpdatedDate
										}
									/>
								</div>
							)}
						</React.Fragment>
					)}
				</React.Fragment>
			)}
			{download && !review && (
				<TitleDataStore sku={title.sku} doNotLoad={true}>
					<div className="column-right">
						<ReviewTitle sku={title.sku} />
					</div>
				</TitleDataStore>
			)}
			{request && request.status === 'approved' && !download && (
				<div className="column-right pad-left-10">
					<ArchiveRequest request={request.id} />
				</div>
			)}
		</div>
	);
};

export default withIsMobile(TitleActions);

TitleActions.propTypes = {
	download: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	review: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	isMobile: PropTypes.func,
	isSelected: PropTypes.bool,
	selectTitle: PropTypes.func,
	title: PropTypes.object,
	doNotShowSelect: PropTypes.bool,
	removeFromCollaborativeList: PropTypes.bool,
	request: PropTypes.object,
	positionBottomRight: PropTypes.bool,
};
